export const DOCUMENTATION_LEGAL_INFO_BY_COUNTRY = {
    LEGAL_INFO: {
        'documentation-legalMiFID': ['5', '5', '4'],
    },
    LEGAL_INFO_BY_COUNTRY: {
        'documentation-legalInfo2': ['4', '4', '4'],
        'documentation-legalMiFID': ['5', '5', '5'],
    },
};
